import { CheckRounded as CheckRoundedIcon } from '@mui/icons-material'
import { Box, Divider, Grid, Typography } from '@mui/material'
import { t } from 'i18next'

const ReviewAction = ({ downlink, error }) => {
  return (
    <Box>
      <Box mb={6}>
        {error && (
          <>
            <Grid
              container
              marginY={2}
              style={{ backgroundColor: '#FA4C4E' }}
              padding={1}
            >
              <Grid>
                <Typography variant="h5"
                  align="right">{t('common.error')}</Typography>
              </Grid>
              <Grid>
                <Typography>
                  {error?.data?.message || error?.data?.error?.error}
                </Typography>
              </Grid>
            </Grid>
            <Divider />
          </>
        )}

        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            marginY={2}
            spacing={2}
          >
            {downlink?.savePreset && (
              <>
                <Grid size={6}
                  py={1}>
                  <Typography variant="h5"
                    align="right">{t('actions.savePreset')}</Typography>
                </Grid>
                <Grid size={6}
                  py={1}>
                  <Typography>{downlink?.savePreset ? <CheckRoundedIcon color="success" /> : ''}</Typography>
                </Grid>
                <Grid size={6}
                  py={1}>
                  <Typography variant="h5"
                    align="right">{t('actions.actionName')}</Typography>
                </Grid>
                <Grid size={6}
                  py={1}>
                  <Typography>{downlink?.name}</Typography>
                </Grid>
              </>
            )}

            <Grid size={6}
              py={1}>
              <Typography variant="h5"
                align="right">{t('actions.action')}</Typography>
            </Grid>
            <Grid size={6}
              py={1}>
              <Typography>{downlink.downlink?.name}</Typography>
            </Grid>

            <Grid size={6}
              py={1}>
              <Typography variant="h5"
                align="right">{t('actions.sendUplink')}</Typography>
            </Grid>
            <Grid size={6}
              py={1}>
              <Typography>
                {downlink?.sendUplink ? t('common.yes') : t('common.no')}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  )
}

export default ReviewAction
